"use strict";
/**
 * Gift Card Balance Checker
 * Handles the gift card balance lookup functionality on the account page
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
function giftCardBalanceChecker() {
    var _this = this;
    var checkBtn = document.getElementById('checkBalanceBtn');
    var codeInput = document.getElementById('giftCardCode');
    var resultDiv = document.getElementById('giftCardResult');
    if (!checkBtn || !codeInput || !resultDiv) {
        return;
    }
    var checkBalance = function () { return __awaiter(_this, void 0, void 0, function () {
        var code, response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    code = codeInput.value.trim();
                    if (!code) {
                        resultDiv.innerHTML = '<p style="color: red;">Please enter a gift card code</p>';
                        return [2 /*return*/];
                    }
                    resultDiv.innerHTML = '<p>Loading...</p>';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch("https://application.rise-ai.com/v1/gift-cards/?shop_url=amiro-test.myshopify.com&code=" + encodeURIComponent(code) + "&from_check_balance=true")];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    console.log('API Response:', data);
                    if (response.ok && data && data.balance !== undefined) {
                        resultDiv.innerHTML = "\n          <div style=\"padding: 15px; background: #f0f8f0; border: 1px solid #c3e6c3; border-radius: 4px;\">\n            <p style=\"margin: 0; font-size: 14px; color: #666;\">Balance:</p>\n            <p style=\"margin: 5px 0 0 0; font-size: 24px; font-weight: 500;\">" + data.balance + "</p>\n          </div>\n        ";
                    }
                    else {
                        resultDiv.innerHTML = "\n          <div style=\"padding: 15px; background: #fff0f0; border: 1px solid #ffcccc; border-radius: 4px;\">\n            <p style=\"margin: 0;\">Invalid gift card code or unable to retrieve balance.</p>\n          </div>\n        ";
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error('Fetch error:', error_1);
                    resultDiv.innerHTML = "\n        <div style=\"padding: 15px; background: #fff0f0; border: 1px solid #ffcccc; border-radius: 4px;\">\n          <p style=\"margin: 0;\"><strong>Error:</strong> " + error_1.message + "</p>\n          <p style=\"margin: 5px 0 0 0; font-size: 12px;\">Check console for details</p>\n        </div>\n      ";
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Click event listener
    checkBtn.addEventListener('click', checkBalance);
    // Allow Enter key to trigger check
    codeInput.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
            checkBalance();
        }
    });
}
exports.default = giftCardBalanceChecker;
